import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { logoutUser } from "../../redux/actions/userActions";
import jwt_decode from "jwt-decode";
import { useHistory, Link, useLocation, NavLink } from "react-router-dom";
import logo from "../../assets/img/logo.png";
import "./Navbar.css";


const AdminNavbar = () => {
  // const userState = useSelector(state=>state.loginUserReducer)
  // const {currentUser} = userState;

  const [navLinkOpen, navLinkToggle] = useState(false);
  const history = useHistory();

  // var decoded = jwt_decode(currentUser);

  const handleNavlinkToggle = () => {
    navLinkToggle(!navLinkOpen);
  };

  const dispatch = useDispatch();
  const logOut = () => {
    dispatch(logoutUser()).then(() => {
      history.push("/login");
    });
  };

  const renderClasses = () => {
    let classes = "navlinks";
    if (navLinkOpen) {
      classes += " active";
    }
    return classes;
  };
  return (
    <div className="navigation position-relative">
      <div className="container">
        <nav className="navbar navbar-expand-lg navbar-light bg-white">
          <a className="navbar-brand" href="index.html">
            <img className="img-fluid" style={{ height: '6rem', width: '6rem' }} src={logo} alt=" V3 Data Intelligence" /></a>
          <button className="navbar-toggler border-0" type="button" data-toggle="collapse" data-target="#navigation"
            aria-controls="navigation" aria-expanded="false" aria-label="Toggle navigation">
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className="collapse navbar-collapse text-center pb-lg-0" id="navigation">
            <ul className="navbar-nav ml-auto">

              <li className="nav-item">
                <a className="nav-link nav-active" href="https://www.v3dataintel.com/home/index.html">Home</a>
              </li>

              <li className="nav-item">
                <a className="nav-link " href="https://www.v3dataintel.com/home/about.html">About Us</a>
              </li>

              <li className="nav-item dropdown">
                <a className="nav-link dropdown-toggle" href="#" role="button" data-toggle="dropdown"
                  aria-haspopup="true" aria-expanded="false">
                  Services
                </a>
                <div className="dropdown-menu">
                  <a className="dropdown-item" href="https://www.v3dataintel.com/home/licensing.html">Data Licensing</a>
                  <a className="dropdown-item" href="https://www.v3dataintel.com/home/hygiene.html">Data Hygiene</a>
                  <a className="dropdown-item" href="https://www.v3dataintel.com/home/enrichment.html">Data Enrichment</a>
                  <a className="dropdown-item" href="https://www.v3dataintel.com/home/marketing.html">Email Marketing</a>
                </div>
              </li>

              <li className="nav-item">
                <a className="nav-link" href="https://www.v3dataintel.com/home/industries.html">Industries</a>
              </li>

              <li className="nav-item">
                <a className="nav-link" href="https://www.v3dataintel.com/home/pricing.html">Pricing</a>
              </li>

              <li className="nav-item">
                <a className="nav-link btn-primary hover-ripple" style={{ color: 'black', borderRadius: '1rem' }} href="https://contact.v3dataintel.com">Contact</a>
              </li>

            </ul>


          </div>
        </nav>
      </div>
    </div>
  );
};

export default AdminNavbar;
